// LandingPage.jsx — vault-meets-research-lab editorial design.
// Composition only; all sections live in src/landing/components/*.
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

import Nav from '../landing/components/Nav';
import Hero from '../landing/components/Hero';
import Marquee from '../landing/components/Marquee';
import Manifesto from '../landing/components/Manifesto';
import Guarantees from '../landing/components/Guarantees';
import Architecture from '../landing/components/Architecture';
import HowItWorks from '../landing/components/HowItWorks';
import BuiltBy from '../landing/components/BuiltBy';
import CTA from '../landing/components/CTA';
import Footer from '../landing/components/Footer';

import '../landing/landing.css';

export default function LandingPage() {
  const navigate = useNavigate();
  const { currentUser } = useAuth();

  // If already logged in, redirect to chat (preserved from prior landing).
  useEffect(() => {
    if (currentUser) {
      navigate('/chat');
    }
  }, [currentUser, navigate]);

  // Reveal-on-scroll observer (matches design's App.jsx).
  useEffect(() => {
    const els = document.querySelectorAll('.qxai-landing .reveal');
    const io = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && e.target.classList.add('in')),
      { threshold: 0.12 }
    );
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);

  return (
    <div className="qxai-landing" data-theme="dark">
      <Nav />
      <Hero />
      <Marquee />
      <Manifesto />
      <Guarantees />
      <Architecture />
      <HowItWorks />
      <BuiltBy />
      <CTA />
      <Footer />
    </div>
  );
}
